import { query } from '@/services/down/dc';

export default {
  namespace: 'dcQuery',
  state: {},

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (callback) callback(response);
    },
  },
};
